import * as React from "react";

const SvgIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 18 17"
    >
        <path
            d="M0 16.2v-2.835q0-.86.358-1.582.359-.722.951-1.101a10.8 10.8 0 0 1 2.577-1.177 9.2 9.2 0 0 1 5.319 0q1.308.392 2.577 1.177.592.38.951 1.101a3.5 3.5 0 0 1 .358 1.582V16.2zm14.727 0v-3.037q0-1.114-.5-2.14a5.1 5.1 0 0 0-1.422-1.759q1.043.153 1.963.52a9.3 9.3 0 0 1 1.718.898q.736.506 1.125 1.126.39.62.389 1.354V16.2zM6.545 8.1q-1.35 0-2.31-1.19-.962-1.19-.962-2.86t.961-2.86T6.545 0t2.312 1.19.961 2.86-.961 2.86T6.545 8.1m8.182-4.05q0 1.67-.961 2.86-.962 1.19-2.312 1.19-.224 0-.572-.063a4 4 0 0 1-.573-.14q.552-.81.849-1.797a7 7 0 0 0 .297-2.05q0-1.063-.297-2.05a6.5 6.5 0 0 0-.849-1.797q.287-.127.573-.165T11.454 0q1.35 0 2.312 1.19.96 1.19.961 2.86M1.637 14.175h9.817v-.81q0-.279-.112-.506a.9.9 0 0 0-.296-.355 9.5 9.5 0 0 0-2.23-1.025 7.8 7.8 0 0 0-2.27-.341q-1.146 0-2.271.341-1.125.342-2.23 1.025a.9.9 0 0 0-.296.355q-.113.227-.113.506zm4.908-8.1q.676 0 1.156-.595.48-.594.48-1.43t-.48-1.43q-.48-.595-1.156-.595T5.39 2.62t-.48 1.43.48 1.43q.48.595 1.155.595"
        ></path>
    </svg>
);

export default SvgIcon;
